export const matchingArtist = [
  {
    id: 1,
    name: "김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당! 내용이 마음에 드네요!",
  },
  {
    id: 2,
    name: "김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당!\n\n내용이 마음에 드네요!",
  },
  {
    id: 3,
    name: "김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당! 내용이 마음에 드네요!",
  },
  {
    id: 4,
    name: "김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당! 내용이 마음에 드네요!",
  },
  {
    id: 5,
    name: "김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당! 내용이 마음에 드네요!",
  },
  {
    id: 6,
    name: "김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당! 내용이 마음에 드네요!",
  },
  {
    id: 7,
    name: "김아무개김아무개김아무개김아무개김아무개김아무개김아무개김아무개김아무개김아무개김아무개김아무개김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당! 내용이 마음에 드네요!",
  },
  {
    id: 8,
    name: "김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당! 내용이 마음에 드네요!",
  },
  {
    id: 9,
    name: "김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당! 내용이 마음에 드네요!",
  },
  {
    id: 10,
    name: "김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당! 내용이 마음에 드네요!",
  },
  {
    id: 11,
    name: "김아무개",
    thumbnail: "https://picsum.photos/200",
    music: "평화주의자",
    artist_nickname: "np",
    title: "제목제목!",
    content: "한번 같이 해봅시당! 내용이 마음에 드네요!",
  },
];

export const StoryList = [
  {
    id: 1,
    status: "finished",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "아티스트 매칭 신청",
    summary: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",
    isLike: true,
    isArtist: true,

    commentList: [],
  },
  {
    id: 13,
    status: "processing",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "입력 필수 정보 수정",
    summary: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",
    isLike: true,
    isMe: true,

    commentList: [],
  },
  {
    id: 2,
    status: "processing",
    thumbnail: "/asset/img/story/2.jpg",
    title: "창안자 댓글",
    summary: "나의 두번째 이야기",
    category: "음식",
    mood: ["금두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",
    musicTitle: "dma...",
    musicContent: "내용이 들어갑니다.",
    likeCnt: "13",
    viewCnt: "10",
    isFunding: true,
    isPick: true,
    isContent: false,
    funding: {
      applicant: [
        {
          name: "이사과",
          id: "123",
          thumbnail: "/asset/img/story/tempHead.svg",
        },
        {
          name: "이사과장",
          id: "1234",
          thumbnail: "/asset/img/story/tempHead2.svg",
        },
        {
          name: "이사과이사",
          id: "12345",
          thumbnail: "/asset/img/story/tempHead.svg",
        },
        {
          name: "이사과이사장",
          id: "123456",
          thumbnail: "/asset/img/story/tempHead2.svg",
        },
        {
          name: "이사과이사이사",
          id: "1234567",
          thumbnail: "/asset/img/story/tempHead.svg",
        },
        {
          name: "이사과이사3이사",
          id: "12345627",
          thumbnail: "/asset/img/story/tempHead2.svg",
        },
      ],
      goal: 1000000,
      current: 500000,
      startDate: "2021.08.01",
      endDate: "2021.08.31",
    },
    isMe: true,
    isBlank: true,
    commentList: [
      {
        name: "이사과",
        id: "123",
        date: "2023.08.10",
        content: `
          <div class="bo_v_comment_content" style="overflow: inherit; height: auto;">
          <p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;">콩스, 네 번째 만남!!</span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;">7월 31일 월요일 오늘은 녹음을 하는 날입니다!!</span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;"><br></span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;font-size:12pt;">시작에 앞서 30일 생일자 밥님과 3일 생일자 시래기님의 생일 축하 노래를 불러 주었습니다!</span>&nbsp;</p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">어색했던 모습은 온데간데없고 어느새 친구처럼 서로 농담을 주고 받는 모습이 정말 보기 좋았습니다</span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;font-size:12pt;">저번 시간 콩스 친구들이 코러스를 녹음했었죠? 오늘은 우선 친구들의 코러스가 들어간 데모곡을 다같이 불러보는 시간을 가졌습니다</span>&nbsp;</p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;">생각보다 많은 친구들이 멜로디와 가사를 외워와서 깜짝 놀랐는데요 다들 주말동안 만발의 준비를 하고 왔나 봅니다</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">몇 번 따라 불러보더니 박자도 잘 맞추는 콩스 친구들... 대단합니다&nbsp;</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">그래서 후렴도 녹음하기로 결정했습니다!!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">다들 부끄러워하면서도 마이크 앞에 서면 금세 진지한 표정을 하고 잘 부르는 모습을 보여 줬습니다</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">또 투표로 징글송도 정하고 가사도 붙여 녹음해 보았는데요</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">투표로 정해진 징글송은 1절 verse 끝에 나오는</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">라다라 라라라라</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">라다라 라라라라</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">의 뒷부분 음을 바꾸었고 "펼쳐질 밝은 미래 선일빅데이터고"를 가사로 붙였습니다!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">만들어진 징글송은 선일빅데이터고 유튜브 시작, 끝에 삽입하거나 종소리로 사용될 예정입니다!!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">그리고 곡 중간중간에 넣을 콩스 친구들의 대화소리와 웃음소리도 녹음했는데요 잔잔히 웃는 것이 어려워 여러 번의 시도 끝에 성공했습니다^^</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">다음 다섯 번째 만남으로 우리학교 로고송라이터 프로젝트는 끝을 맞게 됩니다 이번 만남에서는 처음부터 어색함 없이 대화도 끊이지 않았고 다같이는 잘 부르지만 마이크만 넘겨주면 노래를 멈추고 녹음을 피했던 콩스 친구들이 이제는 혼자서도 잘 부르고 녹음도 여러 번 하는 멋쟁이 여고생들이 되었습니다!!!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">다음 시간에는 맛있는 음식을 먹으며 마지막으로 노래 제목을 짓는 시간을 가질 텐데요</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">마지막까지 콩스 친구들을 응원해 주시길 바랍니다♡♡</span></p>  </div>
        `,
        isNotice: true,

        likeCnt: 12,
        replyList: [],
      },

      {
        name: "이사과",
        id: "1234",
        date: "2023.08.10",
        content: `
          <div class="bo_v_comment_content" style="overflow: inherit; height: auto;">
          <p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;">콩스, 네 번째 만남!!</span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;">7월 31일 월요일 오늘은 녹음을 하는 날입니다!!</span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;"><br></span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;font-size:12pt;">시작에 앞서 30일 생일자 밥님과 3일 생일자 시래기님의 생일 축하 노래를 불러 주었습니다!</span>&nbsp;</p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">어색했던 모습은 온데간데없고 어느새 친구처럼 서로 농담을 주고 받는 모습이 정말 보기 좋았습니다</span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;font-size:12pt;">저번 시간 콩스 친구들이 코러스를 녹음했었죠? 오늘은 우선 친구들의 코러스가 들어간 데모곡을 다같이 불러보는 시간을 가졌습니다</span>&nbsp;</p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;">생각보다 많은 친구들이 멜로디와 가사를 외워와서 깜짝 놀랐는데요 다들 주말동안 만발의 준비를 하고 왔나 봅니다</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">몇 번 따라 불러보더니 박자도 잘 맞추는 콩스 친구들... 대단합니다&nbsp;</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">그래서 후렴도 녹음하기로 결정했습니다!!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">다들 부끄러워하면서도 마이크 앞에 서면 금세 진지한 표정을 하고 잘 부르는 모습을 보여 줬습니다</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">또 투표로 징글송도 정하고 가사도 붙여 녹음해 보았는데요</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">투표로 정해진 징글송은 1절 verse 끝에 나오는</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">라다라 라라라라</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">라다라 라라라라</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">의 뒷부분 음을 바꾸었고 "펼쳐질 밝은 미래 선일빅데이터고"를 가사로 붙였습니다!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">만들어진 징글송은 선일빅데이터고 유튜브 시작, 끝에 삽입하거나 종소리로 사용될 예정입니다!!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">그리고 곡 중간중간에 넣을 콩스 친구들의 대화소리와 웃음소리도 녹음했는데요 잔잔히 웃는 것이 어려워 여러 번의 시도 끝에 성공했습니다^^</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">다음 다섯 번째 만남으로 우리학교 로고송라이터 프로젝트는 끝을 맞게 됩니다 이번 만남에서는 처음부터 어색함 없이 대화도 끊이지 않았고 다같이는 잘 부르지만 마이크만 넘겨주면 노래를 멈추고 녹음을 피했던 콩스 친구들이 이제는 혼자서도 잘 부르고 녹음도 여러 번 하는 멋쟁이 여고생들이 되었습니다!!!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">다음 시간에는 맛있는 음식을 먹으며 마지막으로 노래 제목을 짓는 시간을 가질 텐데요</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">마지막까지 콩스 친구들을 응원해 주시길 바랍니다♡♡</span></p>  </div>
        `,

        likeCnt: 12,
        isLike: true,
        isMe: true,
        replyList: [
          {
            user: {
              name: "커커커헐",
              thumbnail: "/asset/img/story/tempHead.svg",
            },
            id: "123",
            content: "좋은 시작이에요! 재밋었네요! \nㅋㅋㅋ",
            date: "2023.08.10",
          },
          {
            user: {
              name: "ㄷㄷㄷ",
              thumbnail: "/asset/img/story/tempHead2.svg",
            },
            id: "231",
            content: "좋은 시작이에요! \n\n\n\n\n\n\n\nㅋㅋㅋ",
            date: "2023.08.10",
            isMe: true,
          },
          {
            user: {
              name: "커커커헐",
              thumbnail: "/asset/img/story/tempHead.svg",
            },
            id: "1233321",
            content: "좋은 시작이에요! 재ㅋㅋㅋ",
            date: "2023.08.10",
          },
        ],
      },
      {
        name: "이사과",
        id: "12345",
        date: "2023.08.10",
        content: `
          <div class="bo_v_comment_content" style="overflow: inherit; height: auto;">
          <p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;">콩스, 네 번째 만남!!</span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;">7월 31일 월요일 오늘은 녹음을 하는 날입니다!!</span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;"><br></span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;font-size:12pt;">시작에 앞서 30일 생일자 밥님과 3일 생일자 시래기님의 생일 축하 노래를 불러 주었습니다!</span>&nbsp;</p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">어색했던 모습은 온데간데없고 어느새 친구처럼 서로 농담을 주고 받는 모습이 정말 보기 좋았습니다</span></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;font-size:12pt;">저번 시간 콩스 친구들이 코러스를 녹음했었죠? 오늘은 우선 친구들의 코러스가 들어간 데모곡을 다같이 불러보는 시간을 가졌습니다</span>&nbsp;</p><p style="max-width:100%;font-family:Lato, 'Spoqa Han Sans Neo', sans-serif;font-size:16px;background-color:rgb(255,255,255);"><span style="margin:0px;padding:0px;max-width:100%;font-size:12pt;font-family:'나눔고딕', NanumGothic;">생각보다 많은 친구들이 멜로디와 가사를 외워와서 깜짝 놀랐는데요 다들 주말동안 만발의 준비를 하고 왔나 봅니다</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">몇 번 따라 불러보더니 박자도 잘 맞추는 콩스 친구들... 대단합니다&nbsp;</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">그래서 후렴도 녹음하기로 결정했습니다!!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">다들 부끄러워하면서도 마이크 앞에 서면 금세 진지한 표정을 하고 잘 부르는 모습을 보여 줬습니다</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">또 투표로 징글송도 정하고 가사도 붙여 녹음해 보았는데요</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">투표로 정해진 징글송은 1절 verse 끝에 나오는</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">라다라 라라라라</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">라다라 라라라라</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">의 뒷부분 음을 바꾸었고 "펼쳐질 밝은 미래 선일빅데이터고"를 가사로 붙였습니다!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">만들어진 징글송은 선일빅데이터고 유튜브 시작, 끝에 삽입하거나 종소리로 사용될 예정입니다!!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">그리고 곡 중간중간에 넣을 콩스 친구들의 대화소리와 웃음소리도 녹음했는데요 잔잔히 웃는 것이 어려워 여러 번의 시도 끝에 성공했습니다^^</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">다음 다섯 번째 만남으로 우리학교 로고송라이터 프로젝트는 끝을 맞게 됩니다 이번 만남에서는 처음부터 어색함 없이 대화도 끊이지 않았고 다같이는 잘 부르지만 마이크만 넘겨주면 노래를 멈추고 녹음을 피했던 콩스 친구들이 이제는 혼자서도 잘 부르고 녹음도 여러 번 하는 멋쟁이 여고생들이 되었습니다!!!</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><br></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">다음 시간에는 맛있는 음식을 먹으며 마지막으로 노래 제목을 짓는 시간을 가질 텐데요</span></p><p style="max-width:100%;font-size:16px;background-color:rgb(255,255,255);"><span style="font-family:'나눔고딕', NanumGothic;">마지막까지 콩스 친구들을 응원해 주시길 바랍니다♡♡</span></p>  </div>
        `,

        likeCnt: 12,
        isLike: true,
        isLock: true,
        replyList: [
          {
            name: {
              name: "커커커헐",
              thumbnail: "/asset/img/story/tempHead.svg",
            },
            id: "123",
            content: "좋은 시작이에요! 재밋었네요! \nㅋㅋㅋ",
            date: "2023.08.10",
          },
          {
            name: {
              name: "ㄷㄷㄷ",
              thumbnail: "/asset/img/story/tempHead2.svg",
            },
            id: "231",
            content: "좋은 시작이에요! \n\n\n\n\nㅋㅋㅋ",
            date: "2023.08.10",
            isMe: true,
          },
          {
            name: {
              name: "커커커헐",
              thumbnail: "/asset/img/story/tempHead.svg",
            },
            id: "1233321",
            content: "좋은 시작이에요! 재ㅋㅋㅋ",
            date: "2023.08.10",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    status: "processing",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "창안자 매칭 확인",
    summary: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",

    isMe: true,
    isBlank: false,
    commentList: [],
  },
  {
    id: 312,
    status: "processing",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "창안자 매칭 완료",
    summary: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",

    isMe: true,
    isBlank: false,
    commentList: [],
  },
  {
    id: 333131232,
    status: "matching",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "아티스트 매칭 신청 완료",
    summary: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",

    isMe: true,
    isBlank: false,
    commentList: [],
  },
  {
    id: 34,
    status: "processing",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "응원하기",
    summary: "응원하기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",

    isMe: true,
    isBlank: false,
    commentList: [],
    funding: {
      applicant: [
        {
          name: "이사과",
          id: "123",
          thumbnail: "/asset/img/story/tempHead.svg",
        },
        {
          name: "이사과장",
          id: "1234",
          thumbnail: "/asset/img/story/tempHead2.svg",
        },
        {
          name: "이사과이사",
          id: "12345",
          thumbnail: "/asset/img/story/tempHead.svg",
        },
        {
          name: "이사과이사장",
          id: "123456",
          thumbnail: "/asset/img/story/tempHead2.svg",
        },
        {
          name: "이사과이사이사",
          id: "1234567",
          thumbnail: "/asset/img/story/tempHead.svg",
        },
        {
          name: "이사과이사3이사",
          id: "12345627",
          thumbnail: "/asset/img/story/tempHead2.svg",
        },
      ],
      goal: 1000000,
      current: 500000,
      startDate: "2021.08.01",
      endDate: "2021.08.31",
    },
  },
  {
    id: 334,
    status: "processing",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "창작 완료하기",
    summary: "응원하기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",

    isMe: true,
    isBlank: false,
    commentList: [],
  },
  {
    id: 4,
    status: "matching",
    thumbnail: "/asset/img/story/2.jpg",
    title: "창안자 없음",
    category: "음식",
    personality: ["편안한", "행복한"],
    mood: ["난장판", "부드러운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "20",
    viewCnt: "10",
    isMe: true,
    isLike: true,
    commentList: [],
  },
  {
    id: 43,
    status: "matching",
    thumbnail: "/asset/img/story/2.jpg",
    title: "이미 신청한 아티스트",
    category: "음식",
    personality: ["편안한", "행복한"],
    mood: ["난장판", "부드러운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "20",
    viewCnt: "10",
    isMe: true,
    isLike: true,
    commentList: [],
  },
  {
    id: 41233,
    status: "matching",
    thumbnail: "/asset/img/story/2.jpg",
    title: "추가멤버모집",
    category: "음식",
    personality: ["편안한", "행복한"],
    mood: ["난장판", "부드러운"],
    user: "user1",
    artist: "추가멤버모집",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "20",
    viewCnt: "10",
    isArtist: true,
    isLike: true,
    commentList: [],
  },
  {
    id: 4121412333,
    status: "matching",
    thumbnail: "/asset/img/story/2.jpg",
    title: "추가멤버모집 신청",
    category: "음식",
    personality: ["편안한", "행복한"],
    mood: ["난장판", "부드러운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",
    additional: {},
    likeCnt: "20",
    viewCnt: "10",
    isArtist: true,
    isLike: true,
    commentList: [],
  },
  {
    id: 143,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "창작 완료 상태",
    category: "음식",
    personality: ["편안한", "행복한"],
    mood: ["난장판", "부드러운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",
    likeCnt: "20",
    viewCnt: "10",
    isMe: true,
    isLike: true,
    commentList: [],
  },
  {
    id: 6,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
    commentList: [],
  },
  {
    id: 7,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
    commentList: [],
  },
  {
    id: 8,
    status: "matching",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 다섯번째 이야기",
    category: "음식",
    mood: ["난장판", "1231"],
    personality: ["편안한", "행복한"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "41",
    viewCnt: "10",
  },
  {
    id: 9,
    status: "processing",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 두번째 이야기",
    category: "음식",
    mood: ["금두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "10",
    isFunding: true,
    isPick: true,
    funding: {
      goal: 1000000,
      current: 500000,
    },
  },
  {
    id: 10,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 11,
    status: "finished",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",
    isLike: true,
  },
  {
    id: 12,
    status: "processing",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 두번째 이야기",
    category: "음식",
    mood: ["금두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "10",
    isFunding: true,
    isPick: true,
    funding: {
      goal: 1000000,
      current: 500000,
    },
  },
  {
    id: 13,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 14,
    status: "finished",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",
    isLike: true,
  },
  {
    id: 15,
    status: "matching",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 다섯번째 이야기",
    category: "음식",
    mood: ["난장판", "1231"],
    personality: ["편안한", "행복한"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "41",
    viewCnt: "10",
  },
  {
    id: 16,
    status: "processing",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 두번째 이야기",
    category: "음식",
    mood: ["금두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "10",
    isFunding: true,
    isPick: true,
    funding: {
      goal: 1000000,
      current: 500000,
    },
  },
  {
    id: 17,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 18,
    status: "finished",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",
    isLike: true,
  },
  {
    id: 19,
    status: "matching",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 다섯번째 이야기",
    category: "음식",
    mood: ["난장판", "1231"],
    personality: ["편안한", "행복한"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "41",
    viewCnt: "10",
  },
  {
    id: 20,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 21,
    status: "processing",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 두번째 이야기",
    category: "음식",
    mood: ["금두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "10",
    isFunding: true,
    isPick: true,
    funding: {
      goal: 1000000,
      current: 500000,
    },
  },
  {
    id: 22,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 23,
    status: "matching",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 다섯번째 이야기",
    category: "음식",
    mood: ["난장판", "1231"],
    personality: ["편안한", "행복한"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "41",
    viewCnt: "10",
  },
  {
    id: 24,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 25,
    status: "finished",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",
    isLike: true,
  },
  {
    id: 26,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 27,
    status: "processing",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 두번째 이야기",
    category: "음식",
    mood: ["금두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "10",
    isFunding: true,
    isPick: true,
    funding: {
      goal: 1000000,
      current: 500000,
    },
  },
  {
    id: 28,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 29,
    status: "matching",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 다섯번째 이야기",
    category: "음식",
    mood: ["난장판", "1231"],
    personality: ["편안한", "행복한"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "41",
    viewCnt: "10",
  },
  {
    id: 30,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 31,
    status: "finished",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",
    isLike: true,
  },
  {
    id: 32,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 33,
    status: "processing",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 두번째 이야기",
    category: "음식",
    mood: ["금두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "10",
    isFunding: true,
    isPick: true,
    funding: {
      goal: 1000000,
      current: 500000,
    },
  },
  {
    id: 34,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 35,
    status: "matching",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 다섯번째 이야기",
    category: "음식",
    mood: ["난장판", "1231"],
    personality: ["편안한", "행복한"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "41",
    viewCnt: "10",
  },
  {
    id: 36,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
  {
    id: 37,
    status: "finished",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",
    isLike: true,
  },
  {
    id: 38,
    status: "finished",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 여섯번째 이야기",
    category: "음식",
    mood: ["난장판", "ㅋㅋㅋ"],
    personality: ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "23",
    viewCnt: "10",
  },
];

export const exhibitionStoryList = [
  {
    id: 1,
    status: "finished",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 첫번째 이야기",
    category: "음식",
    mood: ["어두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거 ",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "100",
    isLike: true,
  },
  {
    id: 2,
    status: "processing",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 두번째 이야기",
    category: "음식",
    mood: ["금두운", "부드러운"],
    personality: ["조용한", "세심한", "여유로운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "13",
    viewCnt: "10",
    isFunding: true,
    isPick: true,
    funding: {
      goal: 1000000,
      current: 500000,
    },
  },
  {
    id: 3,
    status: "processing",
    thumbnail: "/asset/img/story/1.jpeg",
    title: "나의 세번째 이야기",
    category: "음식",
    personality: ["편안한", "행복한"],
    mood: ["금두운", "흐믈흐믈"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "5",
    viewCnt: "10",
    isFunding: true,
    funding: {
      goal: 1000000,
      current: 1000000,
    },
  },
  {
    id: 4,
    status: "matching",
    thumbnail: "/asset/img/story/2.jpg",
    title: "나의 네번째 이야기",
    category: "음식",
    personality: ["편안한", "행복한"],
    mood: ["난장판", "부드러운"],
    user: "user1",
    artist: "artist1",
    like: "맛있는거",
    dislike: "맛없는거",
    name: "잉여",

    likeCnt: "20",
    viewCnt: "10",
    isLike: true,
  },
  // {
  //   "id": 5,
  //   "status": "matching",
  //   "img": "/asset/img/story/1.jpeg",
  //   "title": "나의 다섯번째 이야기",
  //   "category": "음식",
  //   "mood": ["난장판", "1231"],
  //   "personality": ["편안한", "행복한"],
  //   "user": "user1",
  //   "artist": "artist1",
  //   "like": "맛있는거",
  //   "dislike": "맛없는거",
  //   "name": "잉여",

  //   "likeCnt": "41",
  //   "viewCnt": "10"
  // },
  // {
  //   "id": 6,
  //   "status": "finished",
  //   "img": "/asset/img/story/2.jpg",
  //   "title": "나의 여섯번째 이야기",
  //   "category": "음식",
  //   "mood": ["난장판", "ㅋㅋㅋ"],
  //   "personality": ["리드미컬", "재미있는", "몽환적인", "힙한비트"],
  //   "user": "user1",
  //   "artist": "artist1",
  //   "like": "맛있는거",
  //   "dislike": "맛없는거",
  //   "name": "잉여",

  //   "likeCnt": "23",
  //   "viewCnt": "10"
  // }
];
